import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { FamilyFestTransportDashboardTrendRange } from '@application/features/familyFest/models/family-fest-pickup-location';
import { TransportDashboardTrendRange } from '@application/features/pickupLocation/models/transport-dashboard';
import axios from 'axios';
const MapDashboardTrendEnum = (trendRange) => {
    if (!trendRange)
        return undefined;
    switch (trendRange) {
        case TransportDashboardTrendRange.ThisWeek:
            return FamilyFestTransportDashboardTrendRange.ThisWeek;
        case TransportDashboardTrendRange.LastWeek:
            return FamilyFestTransportDashboardTrendRange.LastWeek;
        case TransportDashboardTrendRange.ThisMonth:
            return FamilyFestTransportDashboardTrendRange.ThisMonth;
        case TransportDashboardTrendRange.LastMonth:
            return FamilyFestTransportDashboardTrendRange.LastMonth;
        case TransportDashboardTrendRange.Last3Months:
            return FamilyFestTransportDashboardTrendRange.Last3Months;
        case TransportDashboardTrendRange.ThisYear:
            return FamilyFestTransportDashboardTrendRange.ThisYear;
        case TransportDashboardTrendRange.LastYear:
            return FamilyFestTransportDashboardTrendRange.LastYear;
        default:
            return undefined;
    }
};
const FamilyFestGetAllPickupLocations = () => {
    return vdkEmHappinessPortalApi.get('/family-fest/pickup-locations');
};
const FamilyFestGetPickupLocationsPaginated = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/pickup-locations/get-all', request);
};
const FamilyFestGetPickupLocationsNotPaginated = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/pickup-locations/get-all-not-paginated', request);
};
const FamilyFestGetPickupLocationById = (id) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/pickup-locations/${id}`);
};
const FamilyFestGetTransportDashboardSummary = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/transport-dashboard/summary', request);
};
const FamilyFestGetTransportDashboardTrend = (request) => {
    const mappedRequest = {
        ...request,
        trendRange: MapDashboardTrendEnum(request.trendRange),
    };
    return vdkEmHappinessPortalApi.post('/family-fest/transport-dashboard/trend', mappedRequest);
};
const FamilyFestCreatePickupLocation = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/pickup-locations', request);
};
const FamilyFestUpdatePickupLocation = (request) => {
    return vdkEmHappinessPortalApi.put('/family-fest/pickup-locations', request);
};
const FamilyFestDeletePickupLocation = (id) => {
    return vdkEmHappinessPortalApi.delete(`/family-fest/pickup-locations/${id}`);
};
const FamilyFestClosePickupLocation = (request) => {
    return vdkEmHappinessPortalApi.put('/family-fest/pickup-locations/close', request);
};
const FamilyFestAssignCoordinator = (assignmentId, pickupLocationId) => {
    return vdkEmHappinessPortalApi.patch('/family-fest/attendee-assignments/assign-coordinator', { assignmentId, pickupLocationId });
};
const FamilyFestUnassignCoordinator = (assignmentId, pickupLocationId) => {
    return vdkEmHappinessPortalApi.patch('/family-fest/attendee-assignments/unassign-coordinator', { assignmentId, pickupLocationId });
};
/** Server-generated .xlsx with attendees assigned to (or unassigned from) a pickup location. */
const downloadFamilyFestPickupLocationAttendeesExcel = async (pickupLocationId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/pickup-locations/${pickupLocationId}/attendees/export-excel`, { pickupLocationId }, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'pickup-location-attendees.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            let message = text;
            try {
                const parsed = JSON.parse(text);
                message = parsed?.message || parsed?.title || parsed?.error || text;
            }
            catch {
                /* not JSON, use raw text */
            }
            throw new Error(message || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
/** Server-generated .xlsx with route information. */
const downloadFamilyFestRouteInformationExcel = async (eventId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/routes/export-excel`, undefined, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'family-fest-route-info.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            throw new Error(text || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
/** Server-generated .xlsx with every pickup location's own details (name, address, status, counts). */
const downloadFamilyFestPickupLocationsExcel = async (eventId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/pickup-locations/export-excel`, undefined, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'family-fest-pickup-locations.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            let message = text;
            try {
                const parsed = JSON.parse(text);
                message = parsed?.message || parsed?.title || parsed?.error || text;
            }
            catch {
                /* not JSON, use raw text */
            }
            throw new Error(message || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
/** Server-generated .xlsx with every pickup location's coordinator, across all companies (no company filter). */
const downloadFamilyFestPickupLocationCoordinatorsExcel = async (eventId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/pickup-locations/coordinators/export-excel`, undefined, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'family-fest-pickup-location-coordinators.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            let message = text;
            try {
                const parsed = JSON.parse(text);
                message = parsed?.message || parsed?.title || parsed?.error || text;
            }
            catch {
                /* not JSON, use raw text */
            }
            throw new Error(message || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
const FamilyFestPickupLocationAPI = {
    FamilyFestGetAllPickupLocations,
    FamilyFestGetPickupLocationsPaginated,
    FamilyFestGetPickupLocationsNotPaginated,
    FamilyFestGetPickupLocationById,
    FamilyFestGetTransportDashboardSummary,
    FamilyFestGetTransportDashboardTrend,
    downloadFamilyFestRouteInformationExcel,
    FamilyFestCreatePickupLocation,
    FamilyFestUpdatePickupLocation,
    FamilyFestDeletePickupLocation,
    FamilyFestClosePickupLocation,
    FamilyFestAssignCoordinator,
    FamilyFestUnassignCoordinator,
    downloadFamilyFestPickupLocationAttendeesExcel,
    downloadFamilyFestPickupLocationsExcel,
    downloadFamilyFestPickupLocationCoordinatorsExcel
};
export default FamilyFestPickupLocationAPI;
